import styled from 'styled-components';

export const LoginPageWrapper = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;

  .logo-section,
  .login-section {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .logo-section {
    width: 40%;
    background-color: #001529;

    img {
      width: 210px;
      height: 210px;
      object-fit: contain;
      transform: scale(1.7);
    }
  }

  .login-section {
    background-color: #f5f7fa;
    width: 60%;
  }
`;
